import LoginComponent from '@bringg/react-components/dist/components/login/login';
import notification from '@bringg/react-components/dist/components/notification/notification';

import { useAuth } from 'Providers';

import './styles.scss';

export function Login() {
  const { login, onLoggedIn, dashboardSdk } = useAuth();

  const onLoginFailed = (e: Error | undefined) => {
    console.error(e);
    notification.error('Failed to login');
  };

  return (
    <div className="login">
      <LoginComponent
        emailPlaceholder="Email"
        invalidEmailText="Email not valid"
        recaptchaSiteKey={dashboardSdk?.config?.recaptcha_site_key || ''}
        loginTitle="Welcome"
        passwordPlaceholder="Password"
        signInText="Sign in"
        onLoggedIn={onLoggedIn}
        onLogin={login}
        onLoginFailed={onLoginFailed}
      />
    </div>
  );
}
